import { PropsWithChildren } from "react";
import { FilterVariant } from "../filter-definition";
import ModalFilter from "./ModalFilter";
import PopoverFilter from "./PopoverFilter";
import {
  ModalDocumentsFilterProvider,
  PopoverDocumentsFilterProvider,
} from "./DocumentsFilterContext";

type DocumentsFilterProps = {
  isSet: boolean;
  name: string;
  buttonName?: string;
  variant: FilterVariant;
} & PropsWithChildren;

const DocumentsFilter = ({
  name,
  buttonName,
  isSet,
  variant,
  children,
}: DocumentsFilterProps) => {
  switch (variant) {
    case "button":
      return (
        <PopoverFilter name={name} buttonName={buttonName} isSet={isSet}>
          <PopoverDocumentsFilterProvider>
            {children}
          </PopoverDocumentsFilterProvider>
        </PopoverFilter>
      );
    case "modal":
      return (
        <ModalFilter name={name} isSet={isSet} buttonName={buttonName ?? name}>
          <ModalDocumentsFilterProvider>
            {children}
          </ModalDocumentsFilterProvider>
        </ModalFilter>
      );
    default:
      return <></>;
  }
};

export default DocumentsFilter;
